export default "/static/dashboard/build/app/img/v2/18ad389aabd9a684333747391772ff8a.png";